import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { safeInternalPath } from '@/utils/safeNext';
import { useAppSelector } from '@state';
import { Button, Center, Text } from '@chakra-ui/react';
import { SelectWithAction } from '@ui';
import { store } from '@state/store';
import { actionExecution } from '@state/utils';
import { actions } from '../../../state/constants/appActions';
const SelectUser: React.FC<{ persist?: boolean }> = ({ persist = true }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = safeInternalPath(searchParams.get('next')) ?? '/';
  const { users, current } = useAppSelector((state) => state.auth);

  useEffect(() =>
  {
    if (persist === true || current.userid === null || current.userid === undefined || Object.keys(users).length !== 1) return;
    else {
      actionExecution({
        action: actions.switchUser,
        dispatch: store.dispatch,
        args: { userid: Number(current.userid) },
      });
      navigate(nextPath, { replace: true });
    }
  }, [persist]);

  return (
    <Center gap={5} flexDirection={'column'}>
      <Text textStyle="heading.card" color="secondary.fg">
        Select User
      </Text>
      <SelectWithAction
        items={Object.entries(users).map(([_, value]) => value)}
        defaultValue={current.userid ? [String(current.userid)] : []}
        placeholder="Select User"
        onSelect={(value: any) => {
          actionExecution({
            action: actions.switchUser,
            dispatch: store.dispatch,
            args: { userid: Number(value) },
          });
          navigate(nextPath, { replace: true });
        }}
        keyForDisplay="username"
        keyForValue="userid"
      />

      <Button
        onClick={() =>
          navigate(
            nextPath !== '/'
              ? `/login?next=${encodeURIComponent(nextPath)}`
              : '/login',
            { state: { isNew: true } },
          )
        }
        variant="plain"
        textDecoration={'underline'}
      >
        Login New User
      </Button>
    </Center>
  );
};

export default SelectUser;
